export { default as Calendar } from './page'


// WEBPACK FOOTER //
// ./src/pages/calendar/index.js